var _path;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgDots = function SvgDots(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 9.188a2.812 2.812 0 1 0 0 5.624 2.812 2.812 0 0 0 0-5.624Zm0 4.5a1.687 1.687 0 1 1 0-3.375 1.687 1.687 0 0 1 0 3.374Zm-7.5-4.5a2.812 2.812 0 1 0 0 5.624 2.812 2.812 0 0 0 0-5.624Zm0 4.5a1.688 1.688 0 1 1 0-3.376 1.688 1.688 0 0 1 0 3.376Zm15-4.5a2.812 2.812 0 1 0 0 5.624 2.812 2.812 0 0 0 0-5.624Zm0 4.5a1.687 1.687 0 1 1 0-3.375 1.687 1.687 0 0 1 0 3.374Z",
    fill: "#343330"
  })));
};
export default SvgDots;